module.exports = __webpack_public_path__ + "img/pdf.93678b5e.png";